(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/gift.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/gift.js');
"use strict";


const Header = svs.tickets_giftshop.gift.components.Header;
const Products = svs.tickets_giftshop.products.Products;
const MiniCart = svs.tickets_giftshop.gift.components.MiniCart;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const GiftForm = svs.tickets_giftshop.gift.giftform.GiftForm;
const {
  TrissBackground,
  SkrapspelBackground
} = svs.components.tur.backgrounds;

const {
  TRISS_HOME,
  SKRAPSPEL_HOME
} = svs.tickets_giftshop.constants.urlMappings;
const {
  TRISS,
  SKRAPSPEL,
  DEFAULT
} = svs.tickets_giftshop.constants.branding;

const functions = svs.tickets_giftshop.functions;
const urlMapping = svs.core.urlMapping;
const {
  appendProductAction
} = svs.tickets_giftshop.gift.giftform.cart.actions;
const {
  inputChangeAction
} = svs.tickets_giftshop.gift.giftform.actions;
const {
  dateSelectorKey,
  names: {
    DATE_AND_TIME,
    DATE_SELECTOR
  }
} = svs.tickets_giftshop.constants;
const Gift = _ref => {
  let {
    jupiterProducts,
    products,
    branding,
    history,
    cartSum,
    onProductAppend,
    onInputChange
  } = _ref;
  const balance = svs.tickets_giftshop.hooks.useBalance();
  const WidgetArea = svs.tickets_giftshop.gift.WidgetArea;
  const handleCancelClick = e => {
    e && e.preventDefault();
    let url;
    switch (branding) {
      case TRISS:
        url = TRISS_HOME;
        break;
      case SKRAPSPEL:
      case DEFAULT:
      default:
        url = SKRAPSPEL_HOME;
        break;
    }
    functions.locationAssign(urlMapping.get(url));
  };

  React.useEffect(() => {
    const {
      paramHandler
    } = svs.utils;
    const lottQuery = paramHandler.get({
      key: 'lott'
    });
    if (lottQuery.value) {
      const parsed = functions.parseTicketQuery(lottQuery.value, jupiterProducts);
      parsed.forEach(_ref2 => {
        let {
          type,
          count,
          variation
        } = _ref2;
        const product = jupiterProducts.find(product => {
          const [name] = type.split(':');
          const [productName] = product.type.split(':');
          return name === productName && variation === product.productVariation;
        });
        for (let i = 0; i < count; i++) {
          product && onProductAppend && onProductAppend(product.productId, product.productVariation, product.type, true, product.activeTheme);
        }
      });
      paramHandler.remove({
        key: 'lott'
      });
    }

    const dateAndTime = paramHandler.get({
      key: 'datum'
    });
    if (dateAndTime.value) {
      const [date, time] = dateAndTime.value.split('T');
      date && time && onInputChange({
        field: DATE_AND_TIME,
        value: {
          date,
          time,
          dateSelector: dateSelectorKey.DATE_AND_TIME
        }
      });
      paramHandler.remove({
        key: 'datum'
      });
    }
    const dateSelector = paramHandler.get({
      key: 'datumflik'
    });
    if (dateSelector.value) {
      const value = dateSelector.value.toUpperCase();
      if (dateSelectorKey[value]) {
        onInputChange({
          field: DATE_SELECTOR,
          value
        });
      }
      paramHandler.remove({
        key: 'datumflik'
      });
    }
  }, []);
  const isTriss = branding === TRISS;
  const isSkrapspel = branding === SKRAPSPEL;
  const isDefault = branding === DEFAULT;

  const previewOpEnabled = {
    isSubmit: true,
    formName: 'tg-gift-form',
    text: 'Förhandsgranska'
  };
  const cancelOp = {
    secondary: true,
    text: 'Avbryt',
    onClick: handleCancelClick
  };
  return React.createElement(React.Fragment, null, isTriss && React.createElement(TrissBackground, null), (isSkrapspel || isDefault) && React.createElement(SkrapspelBackground, null), React.createElement(WidgetArea, {
    areaName: "hero"
  }), React.createElement(Header, null), React.createElement(MiniCart, null), React.createElement(Products, {
    products: products
  }), React.createElement(GiftForm, {
    history: history
  }), React.createElement("div", {
    className: "tg-gift-payfooter"
  }, React.createElement(Payfooter, {
    balance: balance,
    buttons: [previewOpEnabled, cancelOp],
    hasReminder: false,
    isLegalInfo: true,
    sum: cartSum
  })));
};
const mapStateToProps = state => {
  const {
    settings,
    cart,
    products
  } = state;
  const targetCartState = cart[settings.branding] || {};
  return {
    branding: settings.branding,
    jupiterProducts: products.jupiterProducts,
    products: products.products,
    hasItemsInCart: targetCartState.count > 0,
    cartSum: targetCartState.sum
  };
};
const mapDispatch = dispatch => ({
  onProductAppend: (productId, productVariation, productType, viaQueryString, activeTheme) => dispatch(appendProductAction(productId, productVariation, productType, viaQueryString, activeTheme)),
  onInputChange: _ref3 => {
    let {
      field,
      value
    } = _ref3;
    return dispatch(inputChangeAction({
      field,
      value
    }));
  }
});
svs.tickets_giftshop.gift.Gift = ReactRedux.connect(mapStateToProps, mapDispatch)(Gift);

 })(window);